var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDataset(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_138_11566)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 6.79785V4.79785C7 4.24585 6.552 3.79785 6 3.79785H4C3.448 3.79785 3 4.24585 3 4.79785V6.79785C3 7.34985 3.448 7.79785 4 7.79785H6C6.552 7.79785 7 7.34985 7 6.79785Z",
    stroke: "#ED4491",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.846 14.7977V12.9517C7.846 12.3997 7.398 11.9517 6.846 11.9517H5C4.448 11.9517 4 12.3997 4 12.9517V14.7977C4 15.3497 4.448 15.7977 5 15.7977H6.846C7.398 15.7977 7.846 15.3497 7.846 14.7977Z",
    stroke: "#ED4491",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 9.79785V7.79785C14 7.24585 13.552 6.79785 13 6.79785H11C10.448 6.79785 10 7.24585 10 7.79785V9.79785C10 10.3499 10.448 10.7979 11 10.7979H13C13.552 10.7979 14 10.3499 14 9.79785Z",
    stroke: "#ED4491",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 17.7979V14.7979C13 14.2459 13.448 13.7979 14 13.7979H17V10.7979C17 10.2459 17.448 9.79785 18 9.79785H20C20.552 9.79785 21 10.2459 21 10.7979V20.7979C21 21.3499 20.552 21.7979 20 21.7979H10C9.448 21.7979 9 21.3499 9 20.7979V18.7979C9 18.2459 9.448 17.7979 10 17.7979H13Z",
    stroke: "#ED4491",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_138_11566"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.797852)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataset);
export default __webpack_public_path__ + "static/media/Dataset.b91d4b6aa7170e8680cd7a999bdceabc.svg";
export { ForwardRef as ReactComponent };